import { jsx, jsxs } from "react/jsx-runtime";
import { Button, Stack } from "@mui/material";
import { useColorPicker } from "../hooks/useColorPicker.js";
function Footer(props) {
  const { onCommit, onCancel, commitDisabled } = props;
  const {
    localeText,
    router: {
      route: { id }
    }
  } = useColorPicker();
  const commitText = id === "add-color-to-palette" ? localeText.footerButtonAddColor : localeText.footerButtonCommit;
  return /* @__PURE__ */ jsxs(Stack, { alignItems: "center", direction: "row", gap: 1, justifyContent: "flex-end", width: "100%", children: [
    /* @__PURE__ */ jsx(Button, { "data-testid": "TidalColorPickerFooterCancelButton", onClick: onCancel, variant: "text", children: localeText.footerButtonCancel }),
    /* @__PURE__ */ jsx(
      Button,
      {
        color: "primary",
        "data-testid": "TidalColorPickerFooterCommitButton",
        disabled: commitDisabled,
        onClick: onCommit,
        variant: "contained",
        children: commitText
      }
    )
  ] });
}
export {
  Footer
};
//# sourceMappingURL=Footer.js.map
